<!--Task Movement Controls-->
@if 
(
  taskInfoService.activeIndex.label === tabName.Unplannedpickup ||
  taskInfoService.activeIndex.label === tabName.PlannedPBM ||
  taskInfoService.activeIndex.label === tabName.Unloaded ||
  taskInfoService.activeIndex.label === tabName.PushToCloud ||
  (
    taskInfoService.activeIndex.label === tabName.Planned &&
    dataRepositoryService.dateOffset === 0
  )
)
{
<div class="move-controls-dd">
    <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex ml-auto bl-route-selection">
             @if (
            taskInfoService.activeIndex.label === tabName.Unplannedpickup ||
            taskInfoService.activeIndex.label === tabName.PlannedPBM ||
            taskInfoService.activeIndex.label === tabName.Planned
            )
            {
                <div class="target-route">
                    <app-single-select-dropdown [className]="'blom-select'" [width]="'100'"
                        [height]="'32'"
                        [isDisabled]="taskMovementService.isTargetBLSelectionDisabled"
                        [selectedOption]="taskMovementService.selectedTargetBL" [data]="taskMovementService.businessLocationsList"
                        (selectionChange)="taskMovementService.onTargetBLSelection($event)"
                        [placeholder]="'Select Target BL'"></app-single-select-dropdown>
                </div>
            }
            <div>
                <app-single-select-dropdown [className]="'blom-select'" [width]="'100'" 
                    [height]="'32'"
                    [isDisabled]="taskMovementService.isTargetRouteSelectionDisabled"
                    [selectedOption]="taskMovementService.selectedTargetRoute"
                    [data]="taskMovementService.targetRouteSelectionList"
                    (selectionChange)="taskMovementService.onTargetRouteSelection($event)"
                    [placeholder]="'Select Target Route'"></app-single-select-dropdown>
            </div>
        </div>
        <div class="d-flex">
             <ng-container>
                <p-splitButton 
                    [styleClass]="'split-button split-button-primary mx-2'"
                    type="button"
                    [disabled]="taskMovementService.isSubmitDisabled"
                    [appendTo]="'body'"
                    (onClick)="taskMovementService.onSubmitTaskMovement()" [model]="splitItems" label="Move Task"></p-splitButton>
            </ng-container>
            
            <!-- Update State form for task start -->
            @if(
                taskInfoService.activeIndex.label === tabName.PlannedPBM ||
                taskInfoService.activeIndex.label === tabName.Unplannedpickup
                ) {
                    <app-update-state (handleUpdateStateSuccess)="handleUpdateStateSuccess($event)"></app-update-state>
                }
             <!-- Update state form for task end -->

            <!-- Pull Back -->

            @if (
            taskInfoService.activeIndex.label === tabName.PlannedPBM ||
            taskInfoService.activeIndex.label === tabName.Planned
            ) {
                <button class="pn-button pn-button-secondary move-control-button" type="button"
                    [disabled]="taskMovementService.isPullbackDisabled" (click)="confirmPullback()">
                    Pullback
                </button>
            }

            <!-- Reset -->

            <button class="pn-button pn-button-tertiary pn-button-xs " type="button" [disabled]="taskMovementService.isResetDisabled"
                (click)="taskMovementService.resetTaskMovement()">Reset</button>
            
            <img
                [src]="hasActiveTaskBankFilter ? 'assets/image/route_filter_active.svg' : 'assets/image/route_filter.svg'"
                height="26" width="26"
                alt="Task Bank Filter"
                class="ms-1 pointer-cursor"
                (click)="taskBankFilter.toggle($event)"
                [pTooltip]="'Task Bank Filter'"
                tooltipPosition="left" />
            <app-task-bank-filter
                #taskBankFilter>
            </app-task-bank-filter>
        </div>
    </div>
</div>
}

@if(showConsequencesDialog) {
    <p-dialog [(visible)]="showConsequencesDialog" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '60vw' }"
    [style]="{ width: '55vw' }" [draggable]="false" [resizable]="false">

    <ng-template #header>
        <div class="dialog-header">
            <p class="dialog-title mb-0"><b>Consequences</b> - Moving : Weight, Items, Tasks and Stops</p>
            <p class="dialog-subtitle mb-0">Move multiple routes into a single optimised delivery route</p>
        </div>
    </ng-template>
    <app-consequences-dialog #consequencesDialog [(visible)]="showConsequencesDialog">
    </app-consequences-dialog>

    <ng-template #footer>
        <ng-container *ngTemplateOutlet="consequencesDialog.dialogFooter"></ng-container>
    </ng-template>
</p-dialog>
}